<template>
  <div class="batch-card-actions">
    <!--MODALS-->
    <modal
      ref="loadingReceiptModal"
      template="loading"
      title="Aguarde"
      ref-name="loadingReceiptModal"
    >
      <p>Gerando recibo...</p>
    </modal>

    <modal
      ref="loadingGettingSamples"
      template="loading"
      title="Aguarde"
      ref-name="loadingGettingSamples"
    >
      <p>Carregando...</p>
    </modal>

    <modal
      ref="printOpenBatchModal"
      template="question"
      icon-type="impress"
      title="Lote Aberto"
      ref-name="printOpenBatchModal"
      second-button-style="btn-nonenary"
      first-button-sub-text="Manter o lote aberto e imprimir etiquetas"
      :first-button-disabled="areAllSamplesPrinted"
      :second-button-sub-text="secondButtonMessage"
      :close-button-enabled="true"
      class="openBatchModal"
      :warning-enabled="true"
      :warning-text="'Ao imprimir, serão consideradas apenas etiquetas não impressas. <br/> Para reimpressão,'"
      :warning-action="'clique aqui'"
      @first-cta="closeAndPrint({ printOnlySamples: true })"
      @second-cta="closeAndPrint({ printOnlySamples: false })"
      @warning-event="pushToBatchDetails"
    >
      <p>Este lote contém:</p>

      <p v-if="totalSamplesPrinted">
        <strong>
          - {{ totalSamplesPrinted }} amostra
          <template v-if="totalSamplesPrinted > 1">s</template>
          impressa
          <template v-if="totalSamplesPrinted > 1">s</template>
        </strong>

        <span v-if="totalSamplesUnprinted > 0">e</span>
      </p>

      <p v-if="totalSamplesUnprinted">
        <strong>
          - {{ totalSamplesUnprinted }} amostra
          <template v-if="totalSamplesUnprinted > 1">s</template>
          não impressa
          <template v-if="totalSamplesUnprinted > 1">s</template>
        </strong>
      </p>

      <p>
        Você pode mantê-lo aberto e adicionar até
        {{ batch.capability - samplesFromBatchSelected.length }} nova
        <template v-if="batch.capability - samplesFromBatchSelected.length > 1">
          s
        </template>
        amostra
        <template v-if="batch.capability - samplesFromBatchSelected.length > 1">
          s
        </template>
        .

        <br />

        <strong>O que deseja fazer?</strong>
      </p>
    </modal>

    <!-- Pra Impressão Web -->
    <modal
      ref="printOpenBatchModalWeb"
      template="question"
      icon-type="impress"
      title="Lote Aberto"
      ref-name="printOpenBatchModalWeb"
      second-button-style="btn-nonenary"
      first-button-sub-text="Manter o lote aberto e seguir para impressão Web"
      :first-button-disabled="areAllSamplesPrinted"
      :second-button-sub-text="secondButtonMessagePrintWeb"
      :close-button-enabled="true"
      class="openBatchModal"
      :warning-enabled="true"
      :warning-text="'Ao imprimir, serão consideradas apenas etiquetas não impressas. <br/> Para reimpressão,'"
      :warning-action="'clique aqui'"
      @first-cta="showPDF(batch)"
      @second-cta="closeAndPrintWeb({ printOnlySamples: false, batch })"
      @warning-event="pushToBatchDetails"
    >
      <p>Este lote contém:</p>

      <p v-if="totalSamplesPrinted">
        <strong>
          - {{ totalSamplesPrinted }} amostra
          <template v-if="totalSamplesPrinted > 1">s</template>
          impressa
          <template v-if="totalSamplesPrinted > 1">s</template>
        </strong>
        <span v-if="totalSamplesUnprinted > 0">e</span>
      </p>

      <p v-if="totalSamplesUnprinted">
        <strong>
          - {{ totalSamplesUnprinted }} amostra
          <template v-if="totalSamplesUnprinted > 1">s</template>
          não impressa
          <template v-if="totalSamplesUnprinted > 1">s</template>
        </strong>
      </p>

      <p>
        Você pode mantê-lo aberto e adicionar até
        {{ batch.capability - samplesFromBatchSelected.length }} nova
        <template v-if="batch.capability - samplesFromBatchSelected.length > 1">
          s
        </template>
        amostra
        <template v-if="batch.capability - samplesFromBatchSelected.length > 1">
          s
        </template>
        .
        <br />
        <strong>O que deseja fazer?</strong>
      </p>
    </modal>

    <modal
      ref="webSocketPrintOpenBatchModal"
      template="question"
      icon-type="impress"
      title="Lote Aberto"
      ref-name="printOpenBatchModal"
      second-button-style="btn-nonenary"
      first-button-sub-text="Manter o lote aberto e imprimir etiquetas"
      :first-button-disabled="areAllSamplesPrinted"
      :second-button-sub-text="secondButtonMessage"
      :close-button-enabled="true"
      class="openBatchModal"
      :warning-enabled="true"
      :warning-text="'Ao imprimir, serão consideradas apenas etiquetas não impressas. <br/> Para reimpressão,'"
      :warning-action="'clique aqui'"
      @first-cta="webSocketPrintCloseAndPrint({ printOnlySamples: true })"
      @second-cta="webSocketPrintCloseAndPrint({ printOnlySamples: false })"
      @warning-event="pushToBatchDetails"
    >
      <p>Este lote contém:</p>

      <p v-if="totalSamplesPrinted">
        <strong>
          - {{ totalSamplesPrinted }} amostra
          <template v-if="totalSamplesPrinted > 1">s</template>
          impressa
          <template v-if="totalSamplesPrinted > 1">s</template>
        </strong>
        <span v-if="totalSamplesUnprinted > 0">e</span>
      </p>

      <p v-if="totalSamplesUnprinted">
        <strong>
          - {{ totalSamplesUnprinted }} amostra
          <template v-if="totalSamplesUnprinted > 1">s</template>
          não impressa
          <template v-if="totalSamplesUnprinted > 1">s</template>
        </strong>
      </p>

      <p>
        Você pode mantê-lo aberto e adicionar até
        {{ batch.capability - samplesFromBatchSelected.length }} nova
        <template v-if="batch.capability - samplesFromBatchSelected.length > 1">
          s
        </template>
        amostra
        <template v-if="batch.capability - samplesFromBatchSelected.length > 1">
          s
        </template>
        .
        <br />
        <strong>O que deseja fazer?</strong>
      </p>
    </modal>

    <md-dialog
      id="printingClosedBatchModal"
      ref="printingClosedBatchModal"
      md-title
      :md-esc-to-close="false"
      :md-click-outside-to-close="false"
      class="export-print-tag modals print-tag-modal-details print-tag-modal-print"
    >
      <div class="print-tag-modal-column__one">
        <md-dialog-title>
          <div
            v-if="printingLoading"
            class="print-tag-modal-details__title"
          >
            <svg-loader src="/static/images/icon-correct-success.svg" />
            Imprimindo Lote Completo
          </div>

          <div
            v-else
            class="print-tag-modal-details__title"
          >
            <svg-loader src="/static/images/icon-correct-success.svg" />
            Lote Completo
          </div>
        </md-dialog-title>

        <md-dialog-content>
          <div
            v-if="printingLoading"
            class="print-tag-modal-details__description"
          >
            <p>
              <span>Aguarde...</span>
            </p>

            <p>As etiquetas estão sendo impressas.</p>
          </div>

          <div
            v-else
            class="print-tag-modal-details__description"
          >
            <p>
              <span>Impressão concluída com sucesso.</span>
            </p>

            <p>A etiqueta inicial será sempre a do lote, seguida das amostras inclusas</p>
          </div>

          <md-button
            v-if="printingLoading"
            class="btn btn-primary print-tag-modal-details__button button-single"
            disabled
          >
            AGUARDE
          </md-button>

          <md-button
            v-else
            id="btnTurnBackToPrintTagsList"
            class="btn btn-primary print-tag-modal-details__button button-single"
            @click="closeLoadingPrintingModal"
          >
            Voltar para lotes
          </md-button>
        </md-dialog-content>
      </div>

      <div class="print-tag-modal-column__two">
        <transition
          name="fade"
          mode="out-in"
        >
          <div>
            <div class="loaded">
              <svg-loader
                v-if="!printingLoading"
                src="/static/images/icon-correct-success.svg"
              />

              <img
                src="/static/images/label-batch.svg"
                alt="Etiqueta do Lote"
              />
            </div>

            <div class="loaded">
              <svg-loader
                v-if="!printingLoading"
                src="/static/images/icon-correct-success.svg"
              />

              <img
                src="/static/images/label-sample.svg"
                alt="Etiqueta da Amostra"
              />
            </div>
          </div>
        </transition>
      </div>
    </md-dialog>

    <div class="batch-card-actions-buttons">
      <template v-if="isAOL">
        <md-button
          v-if="batch.isPrinted"
          class="btn btn-nonenary"
          :disabled="isCreatingBatch"
          @click="validatePrintingSystem"
        >
          <svg-loader src="/static/images/icon-print-alternative.svg" />

          <span class="btn-label">Reimprimir etiquetas</span>
        </md-button>

        <md-button
          v-else
          class="btn btn-nonenary"
          :disabled="isCreatingBatch"
          @click="validatePrintingSystem"
        >
          <svg-loader src="/static/images/icon-print-alternative.svg" />

          <span class="btn-label">Imprimir etiquetas</span>
        </md-button>

        <md-button
          class="btn btn-nonenary"
          :disabled="isCreatingBatch"
          @click="handleGenerateReceipt"
        >
          <svg-loader src="/static/images/icon-print-alternative.svg" />

          <span class="btn-label">Imprimir recibo</span>
        </md-button>
      </template>

      <template v-else>
        <md-button
          v-if="batch.isPrinted"
          class="btn btn-nonenary"
          :disabled="isCreatingBatch"
          @click="validatePrintingSystem"
        >
          <svg-loader src="/static/images/icon-print-alternative.svg" />

          <span class="btn-label">Reimprimir lote</span>
        </md-button>

        <md-button
          v-else
          class="btn btn-nonenary"
          :disabled="isCreatingBatch"
          @click="validatePrintingSystem"
        >
          <svg-loader src="/static/images/icon-print-alternative.svg" />

          <span class="btn-label">Fechar e imprimir lote</span>
        </md-button>
      </template>
    </div>

    <print-server-alert ref="printServerAlertModal" />

    <printer-modal ref="printerModal" />

    <printer-plugin-download-modal
      ref="printerPluginDownloadModal"
      ref-name="printerPluginDownloadModal"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import notify from '@/api/notification'
import label from '@/api/label'
import batchService from '@/api/batch'
import sampleService from '@/api/sample'

import pdfkit from '@/libs/pdfkit'
import blobstream from '@/libs/blob-stream'

import batch from '@/store/modules/batch'

import mixin from '@/components/PrintLabels/Batches/BatchesMixin'
import PrintServerAlert from '@/components/Dashboard/PrintServerAlert'
import PrinterModal from '@/components/common/printer/PrinterModal'
import PrinterPluginDownloadModal from '@/components/common/printer/PrinterPluginDownloadModal'

const SAMPLES_UNPRINTED_MESSAGE = 'Fechar o lote e imprimir etiquetas'
const SAMPLES_UNPRINTED_MESSAGE_WEB =
  'Fechar o lote e seguir para impressão de etiquetas web'
const ALL_SAMPLES_PRINTED_MESSAGE = 'fechar e imprimir a etiqueta de lote'
const ALL_SAMPLES_PRINTED_MESSAGE_WEB = 'fechar e seguir para impressão web de lote'

export default {
  name: 'BatchCardActions',
  components: {
    PrintServerAlert,
    PrinterModal,
    PrinterPluginDownloadModal,
  },
  mixins: [mixin] /** @todo Tornar o componente independente do mixin. */,
  props: {
    batch: {
      type: Object,
    },
    index: {
      type: Number,
    },
    big: {
      type: String,
    },
  },
  data() {
    return {
      printingLoading: false,
    }
  },
  methods: {
    ...mapActions([
      'printBatchSamples',
      'printReceiptBatchSamples',
      'webSocketPrintAndTransmit',
      'webSocketPrintBatchSamples',
      'printAndTransmit',
      'batchSetCardStatus',
    ]),
    handlePrint() {
      this.handleGenerateReceipt()
    },
    getSamplesByBatchId(batchId) {
      return batchService.getBatchSamples({
        batchId,
        docDelivered: this.$route.query.docDelivered,
      })
    },
    async handleGenerateReceipt() {
      this.openLoadingReceptModal()

      let samples = []

      if (this.batch.source === 'AOLWS') {
        try {
          const response = await sampleService.aolwsSampleByBatch(
            this.batch.batchIdentifier
          )

          samples = response.data?.map(item => {
            return {
              bar_code: item.barcode,
              number_alvaro_order: item.order.alvaroId,
            }
          })
        } catch (error) {
          console.error('Error fetching batch samples.', error)
        }
      } else {
        try {
          const response = await this.getSamplesByBatchId(this.batch.id)

          samples = response.data
        } catch (error) {
          console.error('Error fetching batch samples.', error)
        }
      }

      if (samples?.length > 0) {
        await this.printReceiptBatchSamples({
          samples,
          batch: this.batch,
        })

        this.pushEventToAnalytics('Impressão de recibo de lote')
      } else {
        notify({
          title: 'AVISO:',
          message: 'Não foi possível buscar informações de lote no momento.',
          action: {
            title: 'IR PARA VISUALIZAÇÃO POR AMOSTRAS',
            handler: this.pushToSamplesPage,
          },
        })

        this.pushEventToAnalytics(
          'Impressão de Recibo - Falha ao buscar amostras do lote por ID'
        )
      }

      this.closeLoadingReceptModal()
    },
    validateBeforePrint() {
      if (this.batch.source !== 'AOL2') {
        this.printBatchTag(this.batch)
      } else {
        this.batchSetCardStatus(this.batch.state !== this.BATCH_STATE_PRINTED)
        this.openLoadingGettingSamplesModal()

        this.getSamplesByBatchId(this.batch.id)
          .then(response => {
            this.closeLoadingGettingSamplesModal()
            this.samplesFromBatchSelected = response.data
            if (
              this.samplesFromBatchSelected.length < this.batch.capability &&
              this.batch.state === this.BATCH_STATE_OPENED
            ) {
              this.openQuestionModal()
            } else {
              this.printBatchAndSamples({ printOnlySamplesPrinted: null })
              this.pushEventToAnalytics(
                this.batch.isPrinted
                  ? 'Reimpressão de Lote AOL - Impresso'
                  : 'Impressão de Lote AOL - Não impresso - Fechado'
              )
            }
          })
          .catch(() => {
            this.closeLoadingGettingSamplesModal()

            notify({
              title: 'AVISO:',
              message: 'Não foi possível buscar informações de lote no momento.',
              action: {
                title: 'IR PARA VISUALIZAÇÃO POR AMOSTRAS',
                handler: this.pushToSamplesPage,
              },
            })

            this.pushEventToAnalytics(
              'Impressão de Lote - Falha ao buscar amostras do lote por ID'
            )
          })
      }
    },
    validateBeforePrintWeb() {
      if (this.batch.source !== 'AOL2') {
        this.printBatchTag(this.batch)
      } else {
        this.batchSetCardStatus(this.batch.state !== this.BATCH_STATE_PRINTED)
        this.openLoadingGettingSamplesModal()

        this.getSamplesByBatchId(this.batch.id)
          .then(response => {
            this.closeLoadingGettingSamplesModal()

            this.samplesFromBatchSelected = response.data

            if (
              this.samplesFromBatchSelected.length < this.batch.capability &&
              this.batch.state === this.BATCH_STATE_OPENED
            ) {
              this.openQuestionModalWeb()
            } else {
              this.showPDF(this.batch)
              this.pushEventToAnalytics(
                this.batch.isPrinted
                  ? 'Reimpressão de Lote AOL - Impresso'
                  : 'Impressão de Lote AOL - Não impresso - Fechado'
              )
            }
          })
          .catch(() => {
            this.closeLoadingGettingSamplesModal()

            notify({
              title: 'AVISO:',
              message: 'Não foi possível buscar informações de lote no momento.',
              action: {
                title: 'IR PARA VISUALIZAÇÃO POR AMOSTRAS',
                handler: this.pushToSamplesPage,
              },
            })

            this.pushEventToAnalytics(
              'Impressão de Lote - Falha ao buscar amostras do lote por ID'
            )
          })
      }
    },
    async validateBeforeWebSocketPrint() {
      await this.$store.dispatch('syncPrinterFromStorage')

      if (this.defaultPrinter) {
        if (this.batch.source !== 'AOL2') {
          this.webSocketPrintBatchTag()
        } else {
          this.batchSetCardStatus(this.batch.state !== this.BATCH_STATE_PRINTED)
          this.openLoadingGettingSamplesModal()

          this.getSamplesByBatchId(this.batch.id)
            .then(response => {
              this.samplesFromBatchSelected = response.data
              this.batch.samples = response.data

              if (
                this.samplesFromBatchSelected.length < this.batch.capability &&
                this.batch.state === this.BATCH_STATE_OPENED
              ) {
                this.openQuestionWebSocketModal()
              } else {
                this.webSocketPrintBatchAndSamples({
                  printOnlySamplesPrinted: null,
                })
              }
            })
            .catch(() => {
              notify({
                title: 'AVISO:',
                message: 'Não foi possível buscar informações de lote no momento.',
                action: {
                  title: 'IR PARA VISUALIZAÇÃO POR AMOSTRAS',
                  handler: this.pushToSamplesPage,
                },
              })
            })
            .finally(() => {
              this.closeLoadingGettingSamplesModal()
            })
        }
      } else {
        this.openConfigModal()
      }
    },
    webSocketPrintBatchTag() {
      this.printingLoading = true

      this.openLoadingPrintingModal()

      this.batch.printOnlyBatchTag = true

      if (!this.batch.samples) {
        this.batch.samples = []
      }

      this.webSocketPrintAndTransmit(this.batch).then(() => {
        this.closeLoadingPrintingModal()
      })
    },
    webSocketPrintBatchAndSamples({ printOnlySamplesPrinted }) {
      this.printingLoading = true

      this.openLoadingPrintingModal()

      this.batch.printOnlyBatchTag =
        printOnlySamplesPrinted === null
          ? false
          : this.areAllSamplesPrinted || this.isBatchFromWS
      this.batch.onlySamplesPrinted = printOnlySamplesPrinted

      this.webSocketPrintAndTransmit(this.batch).then(() => {
        this.closeLoadingPrintingModal()
      })
    },
    webSocketPrintCloseAndPrint({ printOnlySamples }) {
      this.closeQuestionWebSocketModal()

      if (printOnlySamples) {
        this.webSocketPrintSamplesUnprinted()
      } else {
        this.webSocketPrintBatchAndSamples({ printOnlySamplesPrinted: false })
      }
    },
    webSocketPrintSamplesUnprinted() {
      this.printingLoading = true

      this.openLoadingPrintingModal()

      this.batch.onlySamplesPrinted = false

      this.webSocketPrintBatchSamples(this.batch).then(() => {
        this.closeLoadingPrintingModal()
      })
    },
    showPDF(batch) {
      const doc = new pdfkit({ size: [165.86, 83.73] })
      const stream = doc.pipe(blobstream())
      var indice
      var ind = 0
      this.createBatchLabel(doc, batch)
      this.getSamplesByBatchId(batch.id)
        .then(response => {
          var samples = response.data
          samples.forEach((element, index) => {
            indice = index
            label.getLabel(element.bar_code).then(response => {
              var samples = response.data
              samples.forEach(async element => {
                this.createSampleLabel(doc, element, indice, ind, stream)
                ind++
              })
            })
          })
        })
        .catch(() => {
          this.closeLoadingReceptModal()
          notify({
            title: 'AVISO:',
            message: 'Não foi possível buscar informações de lote no momento.',
            action: {
              title: 'IR PARA VISUALIZAÇÃO POR AMOSTRAS',
              handler: this.pushToSamplesPage,
            },
          })
          this.pushEventToAnalytics(
            'Impressão de Recibo - Falha ao buscar amostras do lote por ID'
          )
        })
    },
    createSampleLabel(doc, element, indice, ind, stream) {
      let str = element.label
      let regex,
        label,
        name,
        infos,
        barcode,
        exam,
        examDescription,
        mnemonic,
        urgent,
        minimumVolume
      let labelType = str.substring(1, 3)

      if (labelType === 'XA') {
        regex = /(?<=FD)(.*?)(?=FS)/g
        label = str.match(regex)
        name = label[0].replace(/['"]+/g, '').replace(/['^]+/g, '')
        infos = label[1].replace(/['"]+/g, '').replace(/['^]+/g, '')
        barcode = label[3].replace(/['"]+/g, '').replace(/['^]+/g, '')
        exam = label[4].replace(/['"]+/g, '').replace(/['^]+/g, '')
        examDescription = label[5].replace(/['"]+/g, '').replace(/['^]+/g, '')
        mnemonic = label[6].replace(/['"]+/g, '').replace(/['^]+/g, '')
      } else {
        regex = /"(?:\\"|[^"])*"/g
        label = str.match(regex)
        name = label[0].replace(/['"]+/g, '')
        infos = label[1].replace(/['"]+/g, '')
        barcode = label[3].replace(/['"]+/g, '')
        exam = label[4].replace(/['"]+/g, '')
        examDescription = label[5].replace(/['"]+/g, '')
        mnemonic = label[7].replace(/['"]+/g, '')
        urgent = label[8].replace(/['"]+/g, '').replace(/['^]+/g, '')
        minimumVolume = label[6].replace(/['"]+/g, '')
      }
      doc.fontSize(6).text(name, {
        width: 150,
        height: 10,
        align: 'left',
      })
      doc.fontSize(6).text(infos, {
        width: 150,
        height: 15,
        align: 'left',
      })
      doc.image(this.textToBase64Barcode(barcode, 'itf'), 15, 25, {
        width: 120,
        height: 30,
      })
      doc.fontSize(6).text(exam, 10, 55, {
        align: 'left',
      })
      doc.fontSize(6).text(examDescription, 10, 62, {
        align: 'left',
      })
      if (minimumVolume !== '') {
        doc.fontSize(6).text('VOLUME MÍNIMO:' + minimumVolume, 10, 68, {
          align: 'left',
        })
      }
      if (urgent !== '') {
        doc.save()
        doc.rotate(90, { origin: [160, 20] })
        doc.rect(160, 30, 35, 8).fillAndStroke('#black', '#000')
        doc.fillColor('white').fontSize(6).text(urgent, 160, 32).fill('black')
        doc.rotate(90 * -1, { origin: [160, 20] })
        doc.restore()
      }
      doc.rect(123, 57, 33, 10).fillAndStroke('#black', '#000')
      doc.fillColor('white').fontSize(8).text(mnemonic, 123, 59).fill('black')
      if (ind < indice) {
        doc.addPage()
      }
      if (ind === indice) {
        doc.end()
        stream.on('finish', function () {
          const url = stream.toBlobURL('application/pdf')
          window.open(url)
        })
      }
    },
    createBatchLabel(doc, batch) {
      const date = new Date(batch.created_at.substring(0, 19))

      doc.fontSize(8).text(batch.barcode, {
        width: 55,
        height: 10,
        align: 'left',
      })
      doc.fontSize(6).text('Amostras:' + batch.total_samples, 10, 10, {
        align: 'right',
      })
      doc.image(this.textToBase64Barcode(batch.barcode, 'code39'), 12, 20, {
        width: 125,
        height: 40,
      })
      doc.fontSize(6).text(this.profile.id_laboratory, 10, 65, {
        align: 'left',
      })
      doc.fontSize(6).text(date.toLocaleString('pt-BR'), 25, 65, {
        align: 'left',
      })
      doc.fontSize(8).text('NTO-' + batch.label.substring(0, 3), 10, 72, {
        align: 'left',
      })
      doc.fontSize(8).text(':' + this.getPackagingStatusName(batch.packagingId), 45, 72, {
        align: 'left',
      })

      if (batch.urgent === true) {
        doc.save()
        doc.rotate(90, { origin: [160, 20] })
        doc.rect(160, 30, 35, 8).fillAndStroke('#black', '#000')
        doc.fillColor('white').fontSize(6).text('URGENCIA', 160, 32).fill('black')
        doc.rotate(90 * -1, { origin: [160, 20] })
        doc.restore()
      }

      doc.rect(112, 70, 33, 10).fillAndStroke('#black', '#000')

      doc.save()
      doc.rotate(90, { origin: [15, 10] })
      doc.rect(15, 20, 68, 4).fillAndStroke('#black', '#000')

      doc.rotate(90 * -1, { origin: [15, 10] })
      doc.restore()

      doc
        .fillColor('white')
        .fontSize(8)
        .text(batch.mnemonic + '.' + batch.sequence, 112, 72)
        .fill('black')
      doc.addPage()
    },
    getPackagingStatusName(batch) {
      switch (batch) {
        case 25:
          return 'Congelado'
        case 26:
          return 'Refrigerado'
        case 27:
          return 'Ambiente'
        case 208:
          return 'Refrigerado Seco'
        default:
          return 'Outros'
      }
    },
    validatePrintingSystem() {
      if (this.webSocketStatus.connectionState === 'connected') {
        this.validateBeforeWebSocketPrint()
      } else {
        this.$refs.printerPluginDownloadModal.forceOpen()
      }
    },
    textToBase64Barcode(barcode, format) {
      var JsBarcode = require('jsbarcode')
      var canvas = document.createElement('canvas')
      JsBarcode(canvas, barcode, { format: format, displayValue: false })
      return canvas.toDataURL('image/png')
    },
    pushToSamplesPage() {
      this.$router.push({
        path: '/print-tag/samples/',
        query: this.$route.query,
      })
    },
    getSampleSortColumn(value) {
      return value === 'inclusion_order' ? null : value || null
    },
    printBatchAndSamples({ printOnlySamplesPrinted }) {
      this.printingLoading = true

      this.openLoadingPrintingModal()
      this.printAndTransmit([
        {
          batchIdentifier: this.batch.barcode,
          sampleSortColumn: this.getSampleSortColumn(this.batch?.printSortSelected?.value),
          printOnlyBatchTag:
            printOnlySamplesPrinted === null
              ? false
              : this.areAllSamplesPrinted || this.isBatchFromWS,
          onlySamplesPrinted: printOnlySamplesPrinted,
        },
      ])
        .then(response => {
          if (response === 503) {
            this.closeLoadingPrintingModal()
          } else if (response === 428) {
            this.$refs.printServerAlertModal.openPrintServerAlertModal()
          } else {
            this.printingLoading = false
          }
        })
        .catch(() => {
          this.printingLoading = false

          this.closeLoadingPrintingModal()
        })
    },
    printBatchAndSamplesWeb({ printOnlySamplesPrinted, batch }) {
      this.printingLoading = true

      this.openLoadingPrintingModal()
      this.printAndTransmit([
        {
          batchIdentifier: this.batch.barcode,
          sampleSortColumn: this.getSampleSortColumn(this.batch?.printSortSelected?.value),
          printOnlyBatchTag: printOnlySamplesPrinted
            ? this.areAllSamplesPrinted || this.isBatchFromWS
            : false,
          onlySamplesPrinted: printOnlySamplesPrinted,
        },
      ]).then(response => {
        if (response === 503) {
          this.closeLoadingPrintingModal()
        }

        if (response === 428) {
          this.$refs.printServerAlertModal.openPrintServerAlertModal()
        } else {
          this.showPDF(batch)

          this.printingLoading = false
        }
      })
    },
    printBatchTag(batch) {
      this.printingLoading = true
      this.openLoadingPrintingModal()
      this.printAndTransmit([
        {
          batchIdentifier: this.batch.barcode,
          printOnlyBatchTag: true,
        },
      ])
        .then(response => {
          if (response === 503) {
            this.closeLoadingPrintingModal()
          }
          if (response === 428) {
            this.$refs.printServerAlertModal.openPrintServerAlertModal()
          } else {
            this.printingLoading = false
          }
        })
        .catch(() => {
          this.printingLoading = false
          this.closeLoadingPrintingModal()
        })
      this.pushEventToAnalytics(
        batch.isPrinted
          ? 'Reimpressão de Lote WS - Impresso'
          : 'Impressão de Lote WS - Não Impresso'
      )
    },
    printSamplesUnprinted() {
      this.printingLoading = true
      this.openLoadingPrintingModal()
      this.printBatchSamples([
        {
          batchIdentifier: this.batch.barcode,
          sampleSortColumn: this.getSampleSortColumn(this.batch?.printSortSelected?.value),
          onlySamplesPrinted: false,
        },
      ])
        .then(response => {
          if (response === 503) {
            this.closeLoadingPrintingModal()
          }
          if (response === 428) {
            this.$refs.printServerAlertModal.openPrintServerAlertModal()
          } else {
            this.printingLoading = false
          }
        })
        .catch(() => {
          this.printingLoading = false
          this.closeLoadingPrintingModal()
        })
    },
    openQuestionWebSocketModal() {
      this.$refs.webSocketPrintOpenBatchModal.open()
    },
    closeQuestionWebSocketModal() {
      this.$refs.webSocketPrintOpenBatchModal.close()
    },
    openConfigModal() {
      this.$refs.printerModal.open()
    },
    openLoadingGettingSamplesModal() {
      this.$refs.loadingGettingSamples.open()
    },
    closeLoadingGettingSamplesModal() {
      this.$refs.loadingGettingSamples.close()
    },
    openLoadingPrintingModal() {
      this.$refs.printingClosedBatchModal.open()
    },
    closeLoadingPrintingModal() {
      this.$refs.printingClosedBatchModal.close()
    },
    openQuestionModal() {
      this.$refs.printOpenBatchModal.open()
    },
    closeQuestionModal() {
      this.$refs.printOpenBatchModal.close()
    },
    openQuestionModalWeb() {
      this.$refs.printOpenBatchModalWeb.open()
    },
    closeQuestionModalWeb() {
      this.$refs.printOpenBatchModalWeb.close()
    },
    openLoadingReceptModal() {
      this.$refs.loadingReceiptModal.open()
    },
    closeLoadingReceptModal() {
      this.$refs.loadingReceiptModal.close()
    },
    closeAndPrint({ printOnlySamples }) {
      this.closeQuestionModal()

      if (printOnlySamples) {
        this.printSamplesUnprinted()
        this.pushEventToAnalytics(
          'Impressão de Lote AOL - Não impresso - Aberto - Imprimir apenas amostras não impressas'
        )
      } else {
        this.printBatchAndSamples({ printOnlySamplesPrinted: false })
        this.pushEventToAnalytics(
          'Impressão de Lote AOL - Não impresso - Aberto - Imprimir não impressos e fechar lote'
        )
      }
    },
    closeAndPrintWeb({ printOnlySamples, batch }) {
      this.closeQuestionModal()

      if (printOnlySamples) {
        this.printSamplesUnprinted()
        this.pushEventToAnalytics(
          'Impressão de Lote AOL - Não impresso - Aberto - Imprimir apenas amostras não impressas'
        )
      } else {
        this.printBatchAndSamplesWeb({ printOnlySamplesPrinted: false, batch })
        this.pushEventToAnalytics(
          'Impressão de Lote AOL - Não impresso - Aberto - Imprimir não impressos e fechar lote'
        )
      }
    },
    pushToBatchDetails() {
      let id = this.batch.id

      if (this.batch.source === 'AOLWS') {
        id = this.batch.batchIdentifier
      }

      this.$router.push({
        path: `/print-tag/batches/${id}`,
        query: {
          startDate: this.$route.query.startDate,
          endDate: this.$route.query.endDate,
          packagingType: this.$route.query.packagingType,
          tab: this.batchesCurrentTab,
        },
      })
    },
    pushEventToAnalytics(action) {
      this.$analytics.pushAnalyticsEvent('ga-event', {
        category: 'Impressão de Etiquetas - Lote',
        action: action,
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName,
      })
    },
  },
  computed: {
    ...mapGetters([
      'batchesSamplesPrintingStatus',
      'batchesCurrentTab',
      'profile',
      'toggle',
      'webSocketStatus',
      'defaultPrinter',
    ]),
    isAOL() {
      return this.batch.source === 'AOL2'
    },
    batchId() {
      return this.$route.params.batchid
    },
    isViewing() {
      return !!this.batchId
    },
    isCreatingBatch() {
      return this.$route.path === '/create-batch'
    },
    areAllSamplesPrinted() {
      if (this.samplesFromBatchSelected.length > 0) {
        return this.samplesFromBatchSelected.every(elem => elem.printed_status)
      } else {
        return false
      }
    },
    totalSamplesPrinted() {
      if (this.samplesFromBatchSelected.length > 0) {
        return this.samplesFromBatchSelected.filter(elem => elem.printed_status).length
      }
    },
    totalSamplesUnprinted() {
      if (this.samplesFromBatchSelected.length > 0) {
        return this.samplesFromBatchSelected.filter(elem => !elem.printed_status).length
      }
    },
    isBatchFromWS() {
      return this.batch.source === this.BATCH_SOURCE_SYSTEM_WS
    },
    secondButtonMessage() {
      return this.areAllSamplesPrinted
        ? ALL_SAMPLES_PRINTED_MESSAGE
        : SAMPLES_UNPRINTED_MESSAGE
    },
    secondButtonMessagePrintWeb() {
      return this.areAllSamplesPrinted
        ? ALL_SAMPLES_PRINTED_MESSAGE_WEB
        : SAMPLES_UNPRINTED_MESSAGE_WEB
    },
  },
  watch: {
    batchesPrintingStatus(newValue) {
      switch (newValue) {
        case 'STATUS_PRINTING':
          this.$analytics.pushAnalyticsEvent('vpageview', {
            page: '/batches/printing-modal',
            'id-usuario': this.profile.id,
            'id-lab': this.profile.id_laboratory,
            nlab: this.profile.laboratoryName,
          })

          if (this.printingLoading === false) {
            this.openLoadingPrintingModal()
          }

          break

        case 'STATUS_MISSING_CLIENT':
          this.closeLoadingPrintingModal()

          break
      }
    },
    batchesSamplesPrintingStatus(newValue) {
      switch (newValue) {
        case 'STATUS_FAILED':
        case 'STATUS_MISSING_CLIENT':
          this.closeLoadingPrintingModal()

          break
      }
    },
  },
}
</script>

<style lang="scss">
.batch-card-actions {
  width: 100%;

  &-buttons {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .btn {
    display: flex;
    justify-items: center;
    align-items: center;
    height: 2rem;
    min-height: auto;
    border-radius: 0.25rem;
    font-family: 'Exo 2', sans-serif;
    font-weight: 600;
    font-size: 0.75rem;
    text-transform: uppercase;
    margin: 0 !important;
    width: 100%;
    gap: 0.5rem;
  }

  .md-icon {
    width: 1.25rem;
    min-width: auto;
    margin: 0;
    margin-left: auto;
  }

  .btn-label {
    margin-right: auto;
  }

  .md-button {
    &__container-cta {
      max-width: 50em;
    }

    &__ws-source {
      margin-bottom: 17px !important;
    }

    &:hover,
    &:focus {
      .md-icon > svg {
        .print {
          fill: white;
          transition: 1s;
        }
      }
    }
  }

  .batch-ws {
    margin-top: 10px;
    margin-bottom: 20px;
    text-align: center;
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: #4a4a4a;
  }
}

.openBatchModal .md-dialog {
  width: 470px;

  .standard-modal {
    &__container-cta {
      max-width: 29em;
      display: flex;
      padding-top: 25px;

      button {
        padding: 10px 23px;
      }
    }
  }

  .md-dialog-content {
    // For IE
    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
      overflow-x: hidden;
    }
  }
}

.print-tag-modal-print {
  .md-dialog {
    display: flex;
    flex-direction: row;
    max-width: 65%;

    .print-tag-modal-column {
      &__one {
        width: 40%;
      }

      &__two {
        width: 49%;
        display: flex;
        flex-direction: column;
        padding-top: 1em;
        padding-bottom: 1em;
        margin: auto;

        img {
          width: 70%;
          padding: 0.3em;
        }

        .loaded {
          display: flex;
          flex-direction: row;
          justify-content: end;

          .md-icon {
            margin-right: -10px;
            z-index: 10000;
          }
        }
      }
    }
  }
}
</style>
